import { Link, useNavigate } from 'react-router-dom';

// c:\xampp\htdocs\miners-market-main\pages\CategoriesPage.js

export default function CategoriesPage() {
    const navigate = useNavigate();

    // Category data with icons and colors
    const categories = [
        {
            title: 'Equipment',
            icon: 'fas fa-truck-monster',
            color: 'text-blue-600',
            bg: 'bg-blue-50',
            path: '/equipment',
            description: 'Heavy machinery and equipment'
        },
        {
            title: 'Consumables',
            icon: 'fas fa-box-open',
            color: 'text-red-600',
            bg: 'bg-red-50',
            path: '/consumables',
            description: 'Tools, PPE, and daily supplies'
        },
        {
            title: 'Miscellaneous',
            icon: 'fas fa-circle-notch',
            color: 'text-cyan-600',
            bg: 'bg-cyan-50',
            path: '/miscellaneous',
            description: 'Bearings, filters, and spares'
        },
        {
            title: 'Components',
            icon: 'fas fa-cogs',
            color: 'text-emerald-600',
            bg: 'bg-emerald-50',
            path: '/components-and-spares',
            description: 'Parts and components'
        },
        {
            title: 'Rebuilds',
            icon: 'fas fa-tools',
            color: 'text-indigo-600',
            bg: 'bg-indigo-50',
            path: '/rebuilds',
            description: 'Refurbished equipment'
        },
        {
            title: 'Rentals',
            icon: 'fas fa-clock',
            color: 'text-orange-600',
            bg: 'bg-orange-50',
            path: '/rentals',
            description: 'Equipment for rent'
        },
        {
            title: 'Commercial',
            icon: 'fas fa-briefcase',
            color: 'text-purple-600',
            bg: 'bg-purple-50',
            path: '/commercial',
            description: 'Business services and properties'
        },
        {
            title: 'King Price Insurance',
            icon: 'fas fa-shield-alt',
            color: 'text-green-600',
            bg: 'bg-green-50',
            path: '/kp-insurance',
            description: 'Mining insurance solutions'
        },
        {
            title: 'Financing',
            icon: 'fas fa-hand-holding-usd',
            color: 'text-yellow-600',
            bg: 'bg-yellow-50',
            path: '/financeform',
            description: 'Equipment financing options'
        }
    ];

    return (
        <div data-name="categories-page" data-file="pages/CategoriesPage.js" className="min-h-screen bg-gray-900 pb-24 font-sans">
            {/* Header */}
            <div className="bg-white/10 backdrop-blur-md sticky top-0 z-50 shadow-md px-4 py-4 border-b border-white/10">
                <div className="flex items-center gap-3">
                    <button onClick={() => navigate(-1)} className="text-white/80 hover:text-white p-2">
                        <i className="fas fa-arrow-left text-xl"></i>
                    </button>
                    <div className="flex flex-col">
                        <span className="font-extrabold text-white text-xl">Categories</span>
                        <span className="text-white/60 text-sm">Browse our marketplace</span>
                    </div>
                </div>
            </div>

            {/* Categories Grid */}
            <div className="p-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {categories.map((category, index) => (
                        <Link
                            key={index}
                            to={category.path}
                            className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/20 transition-all duration-300 cursor-pointer group"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className={`${category.bg} ${category.color} w-20 h-20 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                                    <i className={`${category.icon} text-3xl`}></i>
                                </div>
                                <h3 className="font-bold text-white text-lg mb-2">{category.title}</h3>
                                <p className="text-white/60 text-sm text-center leading-relaxed">{category.description}</p>
                                <div className="mt-4 flex items-center text-white/40 group-hover:text-white/60 transition-colors">
                                    <span className="text-xs font-medium">Browse</span>
                                    <i className="fas fa-arrow-right ml-2 text-xs"></i>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}
